import React from 'react';
import Catalogo from '../../components/catalogo/Catalogo';


function Produtos() {
    return (
        <div>
            <Catalogo />
        </div>
    )

}

export default Produtos;